import { gql } from '@apollo/client';
import { UpdateOrderAction, OrderState } from '../useUpdateOrder';
import { ORDER_SUMMARY_FRAGMENT, OrderSummary } from '../useOrderSummary';
import { ORDER_ITEM_FRAGMENT, OrderItem } from '../useOrder';

export type UpdateOrderPaymentMethodMutation = {
  updateOrderPaymentMethod: {
    __typename: 'UpdateOrderPaymentMethodPayload';
    data: OrderSummary[];
    included: OrderItem[];
  };
};

export type UpdateOrderPaymentMethodMutationVariables = {
  orderId: string;
  input: {
    data: {
      action_type: UpdateOrderAction.ChangePayment;
      attributes: {
        country_code: string;
        order_state: OrderState.Default;
        selected_payment_id: number;
      };
      id: string;
      type: 'orders';
    };
  };
};

export const UPDATE_ORDER_PAYMENT_METHOD_MUTATION = gql`
  mutation UpdateOrderPaymentMethodMutation(
    $orderId: String!
    $input: UpdateOrderPaymentMethodMutationVariables!
  ) {
    updateOrderPaymentMethod(orderId: $orderId, input: $input)
      @rest(
        type: "UpdateOrderPaymentMethodPayload"
        endpoint: "cart"
        path: "/v3.5/orders/{args.orderId}"
        method: "PATCH"
      ) {
      data @type(name: "RestOrderSummary") {
        ...OrderSummaryFragment
      }
      included @type(name: "RestOrderItem") {
        ...OrderItemFragment
      }
    }
  }
  ${ORDER_SUMMARY_FRAGMENT}
  ${ORDER_ITEM_FRAGMENT}
`;
